import { useEffect, useRef, useState } from 'react';

interface ToastProps {
  message: string;
  type: 'success' | 'error' | 'info';
  onClose: () => void;
}

export default function Toast({ message, type, onClose }: ToastProps) {
  const [visible, setVisible] = useState(false);
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    requestAnimationFrame(() => setVisible(true));
    let dismissTimer: ReturnType<typeof setTimeout>;
    const t = setTimeout(() => {
      setVisible(false);
      dismissTimer = setTimeout(() => {
        onCloseRef.current();
      }, 300);
    }, 2500);

    return () => {
      clearTimeout(t);
      clearTimeout(dismissTimer);
    };
  }, []);

  const colors = {
    success: 'bg-green-600 text-white',
    error: 'bg-red-600 text-white',
    info: 'bg-blue-600 text-white',
  };
  const icons = { success: '✓', error: '✕', info: 'ℹ' };

  return (
    <div
      className={`fixed bottom-6 left-1/2 z-[100] flex items-center gap-2.5 px-5 py-3 rounded-pill shadow-warm-lg text-sm font-medium max-w-[calc(100vw-2rem)] ${colors[type]}`}
      style={{
        transform: `translateX(-50%) translateY(${visible ? 0 : '12px'})`,
        opacity: visible ? 1 : 0,
        transition: 'transform 0.25s ease, opacity 0.25s ease',
      }}
    >
      <span className="text-base leading-none">{icons[type]}</span>
      {message}
    </div>
  );
}
